// ./data/operatingSystems.js
import { FaApple, FaWindows, FaLinux } from 'react-icons/fa';

export const operatingSystems = [
  {
    name: 'macOS',
    icon: FaApple,
    color: '#999999',
    versions: [
      {
        name: 'Intel Chip',
        size: '200.19 MB',
        filename: 'Quartermaster-{version}.dmg',
        url: 'https://release.quartermaster.io/releases/v{version}/mac/intel/Quartermaster-{version}.dmg',
        architecture: 'x64',
      },
      {
        name: 'Apple Silicon',
        size: '199.93 MB',
        url: 'https://release.quartermaster.io/releases/v{version}/mac/arm64/Quartermaster-{version}-arm64.dmg',
        filename: 'Quartermaster-{version}-arm64.dmg',
        architecture: 'arm64',
      },
    ],
    instructions: [
      'Download the appropriate version for your Mac',
      'Open the .dmg file',
      'Drag Quartermaster to Applications folder',
      {
        type: 'command',
        text: 'sudo xattr -r -d com.apple.quarantine Quartermaster.dmg',
        description: 'If you encounter security warning, run:',
      },
      {
        type: 'note',
        text: 'Note: Ensure you have at least 500MB of free space',
      },
    ],
  },
  {
    name: 'Windows',
    icon: FaWindows,
    color: '#00A4EF',
    versions: [
      {
        name: 'Windows 10/11',
        size: '146 MB',
        filename: 'Quartermaster-{version}.exe',
        url: 'https://release.quartermaster.io/releases/v{version}/windows/Quartermaster-{version}.exe',
        architecture: 'x64',
      },
    ],
    instructions: [
      'Download the installer',
      'Run the .exe file as administrator',
      'Follow installation wizard steps',
      'Launch Quartermaster from Start menu',
      {
        type: 'note',
        text: 'Note: You might need to allow the app through Windows Security',
      },
      {
        type: 'note',
        text: 'Note: Ensure you have at least 500MB of free space',
      },
    ],
  },
  {
    name: 'Linux',
    icon: FaLinux,
    color: '#FFA600',
    versions: [
      {
        name: 'Ubuntu/Debian (.deb)',
        size: '115.51 MB',
        url: 'https://release.quartermaster.io/releases/v{version}/linux/quartermaster_{version}_amd64.deb',
        filename: 'quartermaster_{version}_amd64.deb',
        architecture: 'x64',
      },
      {
        name: 'Fedora/RHEL (.rpm)',
        size: '116.42 MB',
        url: 'https://release.quartermaster.io/releases/v{version}/linux/quartermaster-{version}.x86_64.rpm',
        filename: 'quartermaster-{version}.x86_64.rpm',
        architecture: 'x64',
      },
    ],
    instructions: [
      'Download the appropriate package for your distribution',
      'For Ubuntu/Debian, open terminal and run:',
      {
        type: 'command',
        text: 'sudo dpkg -i quartermaster_{version}_amd64.deb',
      },
      'For Fedora/RHEL, open terminal and run:',
      {
        type: 'command',
        text: 'sudo rpm -i quartermaster-{version}.x86_64.rpm',
      },
      'Launch from Applications menu or terminal: quartermaster',
      {
        type: 'note',
        text: 'Note: Ensure you have at least 500MB of free space',
      },
    ],
  },
];
